"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _animations = require("@qc-modules/animations");

var _utils = require("../../utils");

var _documentItem = _interopRequireWildcard(require("../../components/document-item"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["children", "in", "isOpen"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var showResultsPropTypes = {
  /** Default handler for download item onClick */
  downloadAction: _propTypes.func,

  /** Array of results to display */
  visibleItems: (0, _propTypes.arrayOf)(_propTypes.object)
};
var StyledResultItem = (0, _styledComponents["default"])(_documentItem["default"]).withConfig({
  displayName: "results__StyledResultItem",
  componentId: "sc-lfv5fv-0"
})([""]);
var BorderedSlideIn = (0, _styledComponents["default"])(_animations.SlideIn).withConfig({
  displayName: "results__BorderedSlideIn",
  componentId: "sc-lfv5fv-1"
})(["&:last-of-type{", "}", ":last-of-type{border-bottom:none;}"], _documentItem.ResultItemBottomBorderStyle, StyledResultItem);
var mappedSlideInpropTypes = {
  children: _propTypes.node,
  "in": _propTypes.bool,
  isOpen: _propTypes.bool
};

var MappedSlideIn = function MappedSlideIn(_ref) {
  var children = _ref.children,
      animateIn = _ref["in"],
      isOpen = _ref.isOpen,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(BorderedSlideIn, _extends({}, props, {
    animateIn: animateIn,
    show: animateIn && isOpen
  }), children);
};

MappedSlideIn.propTypes = mappedSlideInpropTypes;

var Results = function Results(_ref2) {
  var downloadAction = _ref2.downloadAction,
      visibleItems = _ref2.visibleItems;
  return /*#__PURE__*/_react["default"].createElement(_animations.TransitionGroup, null, (0, _utils.mapIndexed)(function (visibleItem, index) {
    return /*#__PURE__*/_react["default"].createElement(MappedSlideIn, {
      key: visibleItem.id,
      alwaysShowInDom: false,
      delayIn: index * 0.04,
      delayOut: 0,
      enterDuration: 0.25,
      exitDuration: 0,
      fadeInOut: true,
      "in": true,
      isOpen: true,
      vertical: -0.5
    }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, null, /*#__PURE__*/_react["default"].createElement(StyledResultItem, _extends({
      downloadAction: downloadAction
    }, visibleItem))));
  }, visibleItems));
};

Results.propTypes = showResultsPropTypes;
Results.displayName = "Modules.Results";
var _default = Results;
exports["default"] = _default;